<div class="access-point-building-container">
  <div class="d-flex justify-content-between align-items-center">
    <img
      src="/assets/svg/ico-chevron-back-outline.svg"
      class="pointer-cursor"
      (click)="navigateBack()"
    />
    <div>
      <p class="build-user-group mt-2 ml-3 text-center">
        <app-with-tooltip [showHelpCursor]="true">{{
          'GROUPS' | translate
        }}</app-with-tooltip>
      </p>
    </div>

    <div class="col-1">
      <!-- dynamic back button render -->
      <ng-content select="[backButton]"></ng-content>
    </div>
  </div>
  <div class="mt-4 row justify-content-center">
    <div class="col-8">
      <h1 class="text-center heading1">
        {{ 'ASSIGN_ACCESS' | translate }}
      </h1>
    </div>

    <ng-container *ngIf="!toggleFormUnit">
      <div class="col-10">
        <p class="sub-heading">
          {{
            (toggleSubHeading
              ? "SELECT_ANOTHER_BUILDING_TO_GRANT_MORE_ACCESS_POINTS_CONTINUE"
              : "GRANT_ACCESS_TO_USER_BY_SELECTING_A_BULIDING") | translate
          }}
        </p>
      </div>
    </ng-container>
  </div>

  <!-- step form start -->
  <ng-container *ngIf="!toggleFormUnit">
    <div
      *ngIf="formInstance?.entities?.errors && submited"
      class="alert alert-danger my-2 text-center"
      role="alert"
    >
      {{ 'BUILDING_IS_REQUIRED' | translate }}
    </div>
    <form
      [formGroup]="formGroup"
      [ngClass]="{ 'mt-4 pt-3': !(formInstance?.entities?.errors && submited) }"
      tabindex="0"
      (keyup.enter)="submit()"
      #buildingListing
      novalidate
    >
      <div
        class="listing"
        [ngClass]="
          !(formInstance?.entities?.errors && submited)
            ? 'no-error'
            : 'has-error'
        "
      >
        <div class="scroll-container">
          <div class="overflow-y">
            <ng-container
              *ngFor="
                let building of buildingList | sortBy: 'buildingName':'asc';
                let i = index
              "
            >
              <div
                class="form-group rounded-top form-container pr-2"
                [id]="building.buildingId"
              >
                <mat-form-field
                  appearance="fill"
                  class="w-100 building-list-container primary-input bottom-zero padding-top-balance middle"
                >
                  <div
                    class="d-flex list-box full pointer-cursor"
                    (click)="addBuildingUnit(building)"
                  >
                    <span class="align-self-center">
                      <img
                        src="/assets/svg/ico-building-with-black-circle.svg"
                        alt="ico-building-with-black-circle"
                        class="left-icon"
                      />
                    </span>
                    <span class="title bold col-5">
                      <app-with-tooltip [showHelpCursor]="true">
                        {{ building?.buildingName }}
                      </app-with-tooltip>
                    </span>

                    <span
                      class="col-4 selected-value-container align-self-center"
                    >
                      <span
                        class="selected-value align-self-center"
                        *ngIf="building?.buildingCount > 0"
                      >
                        {{ building?.buildingCount }}
                      </span>
                      <span class="btn-not-text col-5">
                        <button class="icon-button" type="button">
                          <img
                            class="icon"
                            src="/assets/svg/ico-chevron-forward-outline.svg"
                          />
                        </button>
                      </span>
                    </span>
                  </div>
                  <input
                    matInput
                    [placeholder]="'ACCESS_TIME_START_TIME' | translate"
                    formControlName="entities"
                    class="d-none"
                  />
                </mat-form-field>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 my-1 mt-3">
          <button
            class="btn btn-danger px-3 w-100 btn-submit"
            [disabled]="formGroup?.invalid"
            type="button"
            (click)="submit()"
          >
            {{ 'CONTINUE' | translate }}
          </button>
        </div>
      </div>
    </form>
  </ng-container>
  <!-- step form end -->

  <!-- step unit and accesspoint list start -->
  <ng-container *ngIf="toggleFormUnit">
    <ng-container *ngIf="floorUnits?.length >= 1">
      <ng-container *ngIf="hasAccessPoints">
        <div class="row justify-content-between mt-3">
          <app-search-field
            (searchCriteria)="searchUnits($event)"
            class="col-12"
          ></app-search-field>
        </div>
        <div
          class="form-group row form-container slide-toggle-primary first mb-1"
        >
          <div class="col-8 pt-4">
            <mat-label class="title">
              <app-with-tooltip [showHelpCursor]="true">{{
                selectedBuilding?.buildingName
              }}</app-with-tooltip></mat-label
            >
          </div>
          <div class="col-2 pt-4">
            {{ 'SELECT_ALL' | translate }}
          </div>
          <div
            class="col-2 pt-3 text-right"
            (keyup.enter)="addUnit()"
            (keydown)="$event.preventDefault()"
          >
            <mat-slide-toggle
              class="mat-toggle"
              color="primary"
              [(ngModel)]="markAll"
              (change)="markList()"
            >
            </mat-slide-toggle>
          </div>
        </div>

        <form
          [formGroup]="formGroup"
          (keyup.enter)="addUnit()"
          (keydown)="$event.preventDefault()"
          novalidate
        >
          <div class="listing unit-list unit-list-height mb-4">
            <div class="scroll-container mt-3">
              <div class="overflow-y">
                <ng-container
                  *ngFor="
                    let floorUnit of floorUnits | orderBy: ['floorName'];
                    let i = index
                  "
                >
                  <ng-container
                    *ngFor="
                      let unit of floorUnit
                        | sortBy: 'accessPointName':'asc'
                        | filterBy: ['unitName', 'accessPointName']:searchUnit;
                      let j = index
                    "
                  >
                    <ng-container *ngIf="j === 0">
                      <div class="row icon-container justify-content-left mb-1">
                        <img
                          src="assets/svg/ico-floor.svg"
                          class="home-icon col-1"
                        />
                        <h2 class="selected-floorName font-weight-bold ml-1">
                          {{ floorUnit.floorName }}
                        </h2>
                        <div class="col-5 px-2 mt-2 ml-auto text-right text">
                          <app-with-tooltip [showHelpCursor]="true">{{
                            floorUnit.wingName
                              ? floorUnit.wingName + " - " + ("WING" | translate)
                              : ""
                          }}</app-with-tooltip>
                        </div>
                      </div>
                    </ng-container>
                    <!-- For object contain AccessPoints start -->
                    <ng-container *ngIf="unit?.accessPointId">
                      <div
                        class="form-group rounded-top form-container pr-2"
                        [attr.data-accessPointId]="unit?.accessPointId"
                        [attr.data-buildingId]="unit?.buildingId"
                        [attr.data-floorId]="unit?.floorId"
                      >
                        <mat-form-field
                          appearance="fill"
                          class="w-100 building-list-container primary-input bottom-zero padding-top-balance middle"
                        >
                          <div class="d-flex list-box full">
                            <span>
                              <img
                                src="assets/images/accesspoint-icon.png"
                                alt="ico-building-with-black-circle"
                                class="left-icon"
                              />
                            </span>
                            <span class="title bold">
                              <app-with-tooltip [showHelpCursor]="true">
                                {{ unit?.accessPointName }}
                              </app-with-tooltip>
                            </span>

                            <span
                              class="selected-value-container checked-spacer"
                            >
                              <span class="selected-value time-right"> </span>
                              <span class="btn-not-text">
                                <button
                                  class="icon-button-checked"
                                  type="button"
                                  (click)="updateUnitStatus(unit)"
                                >
                                  <img
                                    class="icon"
                                    [src]="
                                      unit.status
                                        ? '/assets/svg/ico-checkmark-circle-outline.svg'
                                        : '/assets/svg/ico-circle.svg'
                                    "
                                  />
                                </button>
                              </span>
                            </span>
                          </div>
                        </mat-form-field>
                      </div>
                    </ng-container>
                    <!-- For object contain AccessPoints end -->
                  </ng-container>
                </ng-container>
              </div>
            </div>
          </div>
        </form>
      </ng-container>
    </ng-container>
    <!-- error no floorUnits  start-->
    <ng-container *ngIf="!hasAccessPoints">
      <div class="listing unit-list unit-list-height my-67">
        <div
          class="d-flex flex-column justify-content-center align-items-center h-100"
        >
          <div
            class="text-container d-flex flex-column justify-content-center align-items-center"
          >
            <div class="icon-container">
              <img src="assets/images/accesspoint-icon.png" class="home-icon" />
            </div>
            <div class="text-center mt-3">
              <p>
                {{ 'NO_ACCESS_POINTS_AVAILABLE_IN_THIS_BUILDING' | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <!-- error no floorUnits  end -->
    <div class="row">
      <div class="col-12 my-1">
        <button
          class="btn btn-danger px-3 w-100 btn-submit"
          type="button"
          (click)="addUnit()"
        >
          {{ 'CONTINUE' | translate }}
        </button>
      </div>
    </div>
  </ng-container>
  <!-- step unit and accesspoint list end -->
</div>
